module.exports = __webpack_public_path__ + "static/media/Internationalbanner.d727edbb.png";